import { InterestRate } from '@tcs/client-portal-api/types/InterestRate';
import { useQuery } from '@tcs/common/hooks/useQuery';

interface Props {
  loading: boolean;
  data?: InterestRate[];
}

export const useInterestRates = (options?: { enabled: boolean }): Props => {
  const { data, isLoading: loading } = useQuery<InterestRate[], Error>(
    `/accounts/all/interestRates`,
    options
  );
  return {
    loading,
    data,
  };
};

export default useInterestRates;
